import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'randomFlagInput',
    'questionCountForm',
    'documentsEditForm',
    'addDocumentButton',
    'textRevisionForm',
    'textRevisionDelFlgInput',
    'textRevisionRemoveButton'
  ];

  questionCountFormToggleDisplay() {
    if (!this.hasQuestionCountFormTarget) return;

    this.questionCountFormTarget.hidden = !this.randomFlagInputTarget.checked;
  }

  documentsEditFormTargetConnected() {
    this.addDocumentButtonTarget.classList.toggle('d-none', this.documentsEditFormTargets.length >= 10);
  }

  removeTextRevision(event) {
    if (confirm("テキスト改定を削除しますか？")) {
      const i = this.textRevisionRemoveButtonTargets.indexOf(event.target);

      this.textRevisionFormTargets.at(i).hidden = true;
      this.textRevisionDelFlgInputTargets.at(i).value = 'true';

      this.setOriginalTextRevisionVisibility();
    }
  }

  textRevisionFormTargetConnected() {
    this.setOriginalTextRevisionVisibility();
  }

  setOriginalTextRevisionVisibility() {
    if (this.getNotDeletedTextRevisionCount() == 0) return;
    if (this.getNotDeletedTextRevisionCount() == 1) {
      this.textRevisionFormTargets[0].hidden = true;
    } else {
      this.textRevisionFormTargets[0].hidden = false;
    }
  }

  getNotDeletedTextRevisionCount() {
    if (!this.hasTextRevisionDelFlgInputTarget) return 0;
    return this.textRevisionDelFlgInputTargets.filter(input => input.value !== 'true').length;
  }

}
